import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@holigral/shared/ui/components/ui/dialog"
import BriefFormFields from "./BriefFormFields"
import type { Brief } from "./model"
import { useCreateBriefMutation } from "./api"
import { useT } from "@/i18n"
import { ApiFormWrapper, FormSubmitButton } from "@/form"

type BriefFormValues = {
  name: string
  description: string | null
}

type Props = {
  readonly open: boolean
  readonly onOpenChange: (open: boolean) => void
  readonly onCreated?: (brief: Brief) => void
}

export default function BriefCreateDialog({
  open,
  onOpenChange,
  onCreated,
}: Props) {
  const { t } = useT("brief")
  const [createBrief] = useCreateBriefMutation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("createTitle")}</DialogTitle>
        </DialogHeader>
        <ApiFormWrapper<BriefFormValues, Brief>
          defaultValues={{ name: "", description: "" }}
          action={(values) =>
            createBrief({
              name: values.name,
              description: values.description ?? "",
            })
          }
          successMessage={t("created")}
          resetOnSuccess
          onSuccess={(brief) => {
            onCreated?.(brief)
            onOpenChange(false)
          }}
        >
          <div className="flex flex-col gap-6">
            <BriefFormFields />
            <DialogFooter>
              <FormSubmitButton>{t("create")}</FormSubmitButton>
            </DialogFooter>
          </div>
        </ApiFormWrapper>
      </DialogContent>
    </Dialog>
  )
}
